<template>
  <div class="evaluate-layout" :class="{ isLook, hasBottom }">
    <p class="create-time" v-if="detail.created_at && isLook">
      {{ detail.created_at | dateHM }} &nbsp;评价
    </p>
    <article class="info-grade">
      <div class="info">
        <div class="merchant" v-if="spuInfo && spuInfo.spuId && !workerCode">
          <div class="spu-info">
            <div class="img-ui">
              <img :src="spuInfo.commdtyImage | viewImage(180, 108)" alt="" />
            </div>
            <div class="per-info">
              <div class="name">
                <span>{{ spuInfo.spuName }}</span>
              </div>
              <div class="conent" v-if="spuInfo.skuName">
                <span class="skuName-ui">
                  <label>产品规格：</label>{{ spuInfo.skuName }}</span
                >
              </div>
              <div
                class="conent p-type"
                v-if="workerInfo && workerInfo.workerUid"
              >
                <label>服务人员：</label>
                <p>
                  <span>{{ workerInfo.workerName }}</span
                  ><i>{{ workerInfo.userTypeName }}</i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="workerInfo && workerInfo.workerUid" class="person">
          <div class="img-ui">
            <img :src="avatarEvaluate(workerInfo.headImage)" alt="" />
          </div>
          <div class="per-info">
            <div class="name">
              <span>{{ workerInfo.workerName }}</span
              ><i v-if="workerInfo.userTypeName">{{
                workerInfo.userTypeName
              }}</i>
            </div>
            <div class="conent">
              <label>服务类型：</label>
              <p>
                <span>{{ categoryName ? categoryName : '育儿顾问服务' }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Grade @onChangeGrade="onChangeGrade" :score="detail.score" />
    </article>
    <article v-if="isMaA" class="add">
      <div class="handle-layout">
        <TagList
          @onChangeTag="onChangeTag"
          :commentLabelList="commentLabelListByScore"
        ></TagList>
        <div class="textarea-layout">
          <TextareaAutosize
            class="textarea"
            placeholder="写出您的感受，可以帮助更多小伙伴哦～"
            :minHeight="80"
            :value="initContent"
            @input="onChangeContent"
          ></TextareaAutosize>
        </div>
      </div>
      <Upload :initImgList="initImgList" @onChangeImgList="onChangeImgList" />
    </article>
    <article v-else class="look" :class="{ noContent }">
      <i></i>
      <div class="handle-layout">
        <TagList
          v-if="!isYEGW"
          :commentLabelList="commentLabelList"
          @onChangeTag="onChangeTag"
        ></TagList>
        <div class="content-layout" v-if="detail.content">
          <p>{{ detail.content }}</p>
        </div>
      </div>
      <ImgsLook :imgList="detail.image_urls" />
    </article>
    <!-- 锦旗 -->
    <Pennants
      v-if="pennantsList.length > 0 && loadSuccess"
      @onChangePennants="onChangePennants"
      :jqTip="cmsData.jqTip"
      :pennantsList="pennantsList"
      :workerName="workerInfo.workerName"
    ></Pennants>
    <article class="bottom" v-if="hasBottom">
      <div v-if="isMaA" class="isAdd">
        <button class="submit" @click="submitCurrent">提交评价</button>
      </div>
      <div v-else-if="isOrderLook" class="isLook">
        <button class="delete" @click="deleteCurrent">删除评价</button>
        <button class="modify" @click="modifyCurrent">修改评价</button>
      </div>
      <div class="menu_wkBox_back_box"></div>
    </article>
    <div class="menu_wkBox_back_box"></div>
  </div>
</template>
<script>
import { msgbox } from 'kf-component-vue'
import TextareaAutosize from '@/components/common/textareaAutosize'
import Grade from '@/components/evaluate/grade'
import Pennants from '@/components/evaluate/pennants'
import Upload from '@/components/evaluate/upload'
import TagList from '@/components/evaluate/tagList'
import ImgsLook from '@/components/evaluate/imgsLook'
import { ROLETYPE } from '@/plugins/enum'
import { pushHref, pushReplaceNrNs, pushReplace } from '@/plugins/jump'
import { dateHM } from '@/plugins/date'
import evaluateMixins from '@/components/evaluate/mixins'

import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('evaluate')

import Vue from 'vue'

const avatarAdvi = Vue.filter('avatarAdvi')
const avatarCert = Vue.filter('avatarCert')

function getSessionStorageContent(orderCode) {
  const objString = sessionStorage.getItem('evaluateContent')
  try {
    const obj = JSON.parse(objString)
    if (orderCode && orderCode == obj.orderCode) {
      return obj ? obj.content : ''
    } else {
      return ''
    }
  } catch (e) {
    return ''
  }
}

function setSessionStorage(orderCode, content) {
  const objString = JSON.stringify({ orderCode, content })
  sessionStorage.setItem('evaluateContent', objString)
}

function initPennantsList(list = []) {
  return list.map(item => {
    item.selected = !!item.selected
    return item
  })
}

export default {
  mixins: [evaluateMixins],
  components: {
    Upload,
    Grade,
    Pennants,
    TagList,
    ImgsLook,
    TextareaAutosize
  },
  data() {
    return {
      cmsData: {
        jifen: 100
      },
      pennantsList: [], // 锦旗列表
      commentLabelList: [], //标签列表
      spuInfo: {}, // 商品信息
      workerInfo: {}, // 服务人员信息
      orderInfo: {}, //订单信息
      initImgList: [], //修改上传图片的初始图片
      initContent: '',
      detail: {
        //评价详情
        score: 5, //评价总分-默认5分
        content: '', //评价内容
        image_urls: [], //评价图片
        silkBannerVoList: [], //选择的月嫂锦旗
        labelVoList: [] //选择的标签
      },
      lockHttp: false,
      loadSuccess: false
    }
  },
  computed: {
    isYEGW() {
      //是否是育儿顾问 育儿顾问没有tag 没有积分
      return !!this.workerUid
    },
    hasBottom() {
      return (
        this.isAdd ||
        this.isModify ||
        (this.detail.isModify == 1 && this.orderCode)
      )
    },
    noContent() {
      const cl = this.commentLabelListByScore.length
      const content = this.detail.content
      const il = this.detail.image_urls && this.detail.image_urls.length
      return !cl && !content && !il
    },
    /* 根据评分过滤显示标签 */
    commentLabelListByScore() {
      if (this.detail.score == 4 || this.detail.score == 5) {
        return this.commentLabelList.filter(item =>
          item.type ? item.type == 1 : true
        )
      } else if (this.detail.score >= 1 && this.detail.score <= 3) {
        return this.commentLabelList.filter(item =>
          item.type ? item.type == 2 : true
        )
      } else {
        return this.commentLabelList
      }
    }
  },
  filters: {
    strToArr(str) {
      return str ? str.split(',') : []
    },
    dateHM(timestamp) {
      return dateHM(timestamp)
    }
  },
  async created() {
    console.log(this.workerUid, '>>>')
    this.$$loading(false)
    if (this.isAdd) {
      this.$$title('发布评论')
    } else if (this.isModify) {
      this.$$title('修改评论')
    } else {
      this.$$title('查看评论')
    }
    if (this.isAdd) {
      if (this.workerUid) {
        this.detail.type = 6
      } else {
        this.detail.type = 9
      }
    }
    // if(this.isAdd || this.isModify) {
    // this.$$allowRefreshOrShare(false,false);
    // }

    this.init()
    //window && window.kwapp && window.kwapp.allowRefreshOrShare(false, false)
  },
  mounted() {
    // 默认都不可刷新
    this.$$allowRefreshOrShare(false, false)
  },
  beforeDestroy() {
    if (this.isAdd || this.isModify) {
      this.$$allowRefreshOrShare(true, true)
    }
  },
  methods: {
    ...mapActions([
      'getCmsData',
      'publish',
      'modifyComment',
      'delate',
      'getDetail',
      'getCommentLabelList',
      'getCommentConfiguration'
    ]),
    async init() {
      this.cmsData = await this.getCmsData()
      if (this.isAdd || this.isModify || this.orderCode) {
        await this.$$ensureLogin()
        if (this.isAdd)
          this.initContent = getSessionStorageContent(this.orderCode)
      }
      // 锦旗 订单新增有 不可修改 -> 月嫂品类才有
      if (!this.workerUid && this.isAdd)
        this.pennantsList = initPennantsList(this.cmsData.jqImgList)

      if (this.workerUid) this.getWorkerInfo(this.workerUid)
      if (this.commentId) this.getCommentDetail(this.commentId)
      if (this.orderCode && !this.commentId) this.getOrderDetail(this.orderCode)
    },
    async getCommentDetail(commentId) {
      const response = await this.getDetail({ comment_id: commentId })
      if (response && response.errno == 0) {
        const detail = response.data
        this.commentLabelList = detail.lableList || []
        if (
          this.isLook &&
          detail.silkBannerVoList &&
          detail.silkBannerVoList.length > 0
        ) {
          const pennantsList = this.cmsData.jqImgList.filter(
            item =>
              detail.silkBannerVoList.findIndex(
                el => el.silkBannerCode == item.silkBannerCode
              ) > -1
          )
          this.pennantsList = initPennantsList(pennantsList)
        } else if (this.isModify) {
          if (detail.silkBannerVoList && detail.silkBannerVoList.length > 0) {
            const pennantsList = this.cmsData.jqImgList
              .map(item => {
                const index = detail.silkBannerVoList.findIndex(
                  el => el.silkBannerCode == item.silkBannerCode
                )
                if (index > -1) {
                  item.selected = true
                }
                return item
              })
              .filter(item => item.selected)
            this.pennantsList = initPennantsList(pennantsList)
          }

          this.initImgList = detail.image_urls
          if (!this.isYEGW) {
            try {
              let commentLabelList = []
              if (
                detail.extend &&
                detail.extend.workerInfo &&
                detail.extend.workerInfo.userType == 1
              ) {
                /* （临时）商品的服务人员是育儿顾问，从成长加接口获取可配置的标签 */
                const spuId =
                  detail.extend && detail.extend.spuInfo
                    ? detail.extend.spuInfo.spuId
                    : ''
                const { uid, skey } = await this.$$ensureLogin()
                const commentConfiguration = await this.getCommentConfiguration(
                  { spuId, uid, skey }
                )
                const tagList = commentConfiguration.tagList || []
                commentLabelList = tagList.map(item => ({
                  id: item.id,
                  labelName: item.name,
                  type: item.type
                }))
              } else {
                const category4Id =
                  detail.extend && detail.extend.spuInfo
                    ? detail.extend.spuInfo.level4CategoryId
                    : ''
                commentLabelList = await this.getCommentLabelList({
                  category4Id
                })
              }
              if (commentLabelList && commentLabelList.length > 0) {
                this.commentLabelList = commentLabelList.map(item => {
                  if (detail.lableList.findIndex(el => el.id == item.id) > -1) {
                    item.selected = true
                  }
                  return item
                })
              }
            } catch (e) {}
          }
        }
        detail.labelVoList = this.commentLabelList
          .filter(item => item.selected)
          .map(item => {
            return {
              id: item.id,
              labelName: item.labelName
            }
          })
        this.detail = detail
        this.initContent = this.detail.content
        const extend = detail.extend || {}
        this.spuInfo = extend.spuInfo
        this.workerInfo = extend.workerInfo
        this.loadSuccess = true
      } else if (response.errmsg) {
        this.$$toast(response.errmsg)
      }

      this.$$loading(false)
    },
    async getOrderDetail(orderCode) {
      try {
        const { uid, skey } = await this.$$ensureLogin()
        const json = await this.$store.dispatch('getOrderDetail', {
          orderCode,
          uid,
          skey,
          toComment: true
        })
        if (json.code == 1) {
          const {
            spuId,
            skuName,
            spuName,
            commdtyImage,
            workerUid,
            workerName,
            userType,
            userTypeDesc,
            level4Category,
            level4CategoryId,
            headImage,
            serviceCode,
            workerStoreCode,
            workerStoreName
          } = (this.orderInfo = json.data)
          this.spuInfo = {
            spuId,
            skuName,
            spuName,
            commdtyImage,
            level4Category,
            level4CategoryId
          }
          this.workerInfo = {
            workerUid,
            workerName,
            userType,
            userTypeName: userTypeDesc,
            headImage,
            workerCode: serviceCode,
            storeCode: workerStoreCode,
            storeName: workerStoreName
          }
          if (!this.isYEGW) {
            if (userType == 1) {
              /* （临时）商品的服务人员是育儿顾问，从成长加接口获取可配置的标签 */
              const commentConfiguration = await this.getCommentConfiguration({
                spuId,
                uid,
                skey
              })
              const tagList = commentConfiguration.tagList || []
              this.commentLabelList = tagList.map(item => ({
                id: item.id,
                labelName: item.name,
                type: item.type
              }))
            } else {
              this.commentLabelList = await this.getCommentLabelList({
                category4Id: level4CategoryId
              })
            }
          }
          // 非月嫂品类商品不显示锦旗
          if (!this.isYuSaoCategory(level4CategoryId)) {
            this.pennantsList = []
          }
          this.loadSuccess = true
        } else if (json.msg) {
          this.$$toast(json.msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$$loading(false)
      }
    },
    async getWorkerInfo(uid) {
      try {
        const data = await this.$store.dispatch('getUserInfoData', {
          uid
        })
        if (data.code == 1 && data.data) {
          const {
            uid: workerUid,
            workerName,
            userType,
            userTypeName,
            headImage,
            workerCode,
            storeCode,
            storeName
          } = data.data.worker
          this.workerInfo = {
            workerUid,
            workerName,
            userType,
            userTypeName,
            headImage,
            workerCode,
            storeCode,
            storeName
          }
          this.detail.object_id = workerCode
          this.detail.workerCode = workerCode
        } else if (data.code * 1 === 20) {
          // 离职和查不到数据都跳社区
          location.replace(`//shequ.cekid.com/bbs/user/${uid}`)
        }
      } catch (e) {
      } finally {
        this.$$loading(false)
      }
    },
    isYuSaoCategory(level4CategoryId = '') {
      //月嫂品类商品 签约月嫂  10112210 联营月嫂10112211 甄选10112212
      const list = [10112210, 10112211, 10112212]
      return list.findIndex(num => num == level4CategoryId) > -1
    },
    // 改评分
    onChangeGrade(score) {
      this.detail.score = score
      this.onChangeTag(this.commentLabelListByScore)
    },
    // 改输入内容
    onChangeContent(value) {
      this.detail.content = value
      if (this.isAdd) {
        setSessionStorage(this.orderCode, this.detail.content)
      }
    },
    //改图片
    onChangeImgList(imgList) {
      this.imgList = imgList.map(item => {
        return item && item.data && item.data.res && item.data.res.content
      })
      const image_urls = this.imgList.map(item => item.downloadUrl)
      this.detail.image_urls = image_urls.join(',')
    },
    //改锦旗
    onChangePennants(list) {
      //const pennants = list.map(item =>item.title);
      const pennants = []
      list.forEach(item => {
        const { silkBannerCode, silkBannerName, silkBannerDesc } = item
        pennants.push({
          silkBannerCode,
          silkBannerName,
          silkBannerDesc
        })
      })
      this.detail.silkBannerVoList = pennants
    },
    //改标签
    onChangeTag(list) {
      const labelVoList = list
        .filter(item => item.selected)
        .map(item => {
          const { id, labelName } = item
          return { id, labelName }
        })
      this.detail.labelVoList = labelVoList
    },
    //提交评价
    async submitCurrent() {
      const { uid, skey } = await this.$$ensureLogin()
      const spuInfo = this.spuInfo || {}
      const workerInfo = this.workerInfo || {}
      const object_id = this.detail.object_id
        ? this.detail.object_id
        : this.workerUid && workerInfo.workerCode
        ? workerInfo.workerCode
        : spuInfo.spuId //人的入口取workerCode
      const workerCode = workerInfo.workerCode || ''
      const workerName = workerInfo.workerName || ''
      const commentId = this.commentId
      const order_id = this.orderCode || ''
      const categoryId = spuInfo.level4CategoryId || ''
      const storeCode = workerInfo.storeCode || this.detail.storeCode || ''
      const storeName = workerInfo.storeName || this.detail.storeName || ''
      const source = this.$$getDevice()
      const extend = JSON.stringify({
        spuInfo,
        workerInfo
      })
      let image_urls = ''
      if (typeof this.detail.image_urls !== 'string') {
        image_urls = this.detail.image_urls.join(',')
      } else {
        image_urls = this.detail.image_urls
      }
      console.log('@@@@@@@@@@@@@skey', skey)
      const query = {
        ...this.detail,
        commentId,
        uid,
        skey,
        object_id,
        order_id,
        workerCode,
        workerName,
        source,
        extend,
        image_urls,
        categoryId,
        storeCode,
        storeName
      }
      let response

      if (this.lockHttp) return
      // 锁定请求 防止多次连续点击
      this.lockHttp = true
      if (this.isAdd) {
        response = await this.publish(query)
      } else {
        response = await this.modifyComment(query)
      }
      this.lockHttp = false
      // if(response && response.code * 1 === 4){
      // this.$$login()
      // return
      // }

      if (response && response.errno * 1 === 0) {
        if (this.workerUid) {
          this.$$toast('评价成功')
          setTimeout(() => {
            window.history.go(-1)
          }, 1500)
        } else if (this.orderCode) {
          const query = {
            spuId: spuInfo.spuId || '',
            home_worker_uid: workerInfo.workerUid || ''
          }
          const params = { orderCode: this.orderCode }
          pushReplaceNrNs({ name: 'comment-success', params, query })
        }
      } else if (response && (response.errmsg || response.msg)) {
        this.$$toast(response.errmsg || response.msg)
      }

      //this.$router.push({query:{...query,ht:'look'}})
    },
    //修改评价
    modifyCurrent() {
      const query = this.$route.query
      pushHref({
        query: { ...query, ht: 'modify', cmd: 'share', sharetype: 0 }
      })
    },
    //删除评价
    async deleteCurrent() {
      msgbox.confirm({
        message: '删除后无法恢复',
        action: msgbox => {
          this.deleteCommentById()
          //msgbox.close() // 提供 msgbox.close() 进行手动关闭
        }
      })
      //
    },
    async deleteCommentById() {
      const { uid, skey } = await this.$$ensureLogin()
      const comment_id = this.commentId
      const response = await this.delate({ uid, skey, comment_id })
      if (response && response.errno == 0) {
        this.$$toast('删除成功')
        setTimeout(() => {
          pushReplace({
            name: 'order-list',
            query: {
              cmd: 'share',
              sharetype: '0'
            }
          })
        }, 1500)
      } else if (response && response.errmsg) {
        this.$$toast(response.errmsg)
      }
    },
    avatarEvaluate(url) {
      try {
        return this.workerInfo && this.workerInfo.userType == 1
          ? avatarAdvi(url, 120, 120)
          : avatarCert(url, 120, 120)
      } catch (e) {
        return url
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.evaluate-layout {
  padding: rem(20px) rem(24px);
  padding-bottom: rem(24px);
  .create-time {
    font-size: rem(24px);
    color: #666666;
    line-height: rem(30px);
    padding-top: rem(16px);
    padding-bottom: rem(20px);
    text-align: center;
  }
  &.hasBottom {
    padding-bottom: rem(130px);
  }
  &.isLook {
    .info-grade {
      border-radius: 0;
      border-top-left-radius: rem(16px);
      border-top-right-radius: rem(16px);
    }
    .look {
      background-color: #fff;
      border-bottom-left-radius: rem(16px);
      border-bottom-right-radius: rem(16px);
      overflow: hidden;

      padding: rem(36px) rem(24px);
      padding-top: 0;
      i {
        display: block;
        padding-top: rem(36px);
        height: 1px;
        @include border(top, #e8e8e8, 1px);
      }
      &.noContent {
        i {
          display: none;
        }

        padding: 0;
        padding-bottom: rem(16px);
        border-bottom-left-radius: rem(16px);
        border-bottom-right-radius: rem(16px);
      }
      .tag-list {
        margin-top: rem(-20px);
        @include border(bottom, #e8e8e8, 0);
      }
      .content-layout {
        font-size: rem(26px);
        color: #262626;
        letter-spacing: 0;
        line-height: rem(42px);
        margin-bottom: rem(24px);
        p {
          word-break: break-all;
        }
      }
    }
  }
}
.info-grade {
  background-color: #fff;
  padding: rem(36px) rem(24px);
  border-radius: rem(16px);
  .person {
    display: flex;
    align-items: center;
  }
  .info {
    .per-info {
      overflow: hidden;
      .name {
        display: flex;
        align-items: center;
        padding-bottom: rem(4px);
        span {
          font-size: rem(28px);
          line-height: 17px;
          color: #000000;
          @include ellicpsis;
        }
        i {
          margin-left: rem(8px);
          color: #ff397e;
          border-radius: 9px;
          background-color: #ffe0eb;
          font-size: 12px;
          padding: 0 rem(12px);
          @include tagCenter(16px);
        }
      }
      .conent {
        margin-top: rem(6px);
        line-height: rem(32px);
        font-size: rem(24px);
        color: #999;
        display: flex;
        @include ellicpsis;
        label {
          color: #999999;
          flex: none;
        }
        p {
          display: flex;
          flex-wrap: wrap;
          span {
            display: inline-block;
          }
        }
        .skuName-ui {
          color: #999999;
          flex: auto;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space: normal;
        }
        &.p-type {
          overflow: hidden;
          white-space: normal;
          color: #999999;
          p {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            span {
              display: block;
              flex: auto;
              @include ellicpsis;
              max-width: 5em;
            }
            i {
              flex: none;
              margin-left: rem(8px);
              border-radius: 9px;

              font-size: 12px;
              color: #ff862c;

              padding: 0 rem(12px);
              background: #ffede0;
              @include tagCenter(16px);
            }
          }
        }
      }
    }
  }
  .img-ui {
    overflow: hidden;
    margin-right: rem(24px);
    flex: none;
    width: rem(180px);
    height: rem(108px);
    border-radius: rem(16px);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .person {
    .img-ui {
      border-radius: 100%;
      width: rem(120px);
      height: rem(120px);
    }
  }
}
.spu-info {
  display: flex;
  align-items: flex-start;
}
.add {
  margin-top: rem(20px);
  background-color: #fff;
  border-radius: rem(16px);
  overflow: hidden;
  .handle-layout {
    padding: rem(16px) rem(24px);
  }
}
.textarea-layout {
  padding: rem(24px) 0;
  .textarea {
    min-height: rem(160px);
    width: 100%;
    background: url('~@/assets/images/icon-write@3x.png') no-repeat left top;
    background-size: rem(30px) auto;
    line-height: rem(38px);
    padding-left: rem(42px);
    border: 0;
    display: block;
    font-size: rem(26px);
    color: #262626;
    word-break: break-all;
  }
}

.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  right: 0;
  padding: rem(16px) rem(30px);
  box-shadow: 0 -7px 14px 0 rgba(0, 0, 0, 0.03);
  background-color: #fff;
  .submit {
    background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    height: rem(78px);
    border-radius: rem(78px);
    font-size: rem(32px);
    color: #fff;
    line-height: rem(78px);
    text-align: center;
    width: 100%;
  }
  .isLook {
    display: flex;
    justify-content: flex-end;
    margin: 0 rem(-26px);
    button {
      margin-right: rem(20px);
      height: rem(60px);
      padding: 0 rem(24px);
      font-size: rem(24px);
      line-height: rem(60px);
      color: #121212;
      @include border(all, #999, 1px, 0.6rem);
    }
  }
}
</style>
